var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var UploadRequest = /** @class */ (function (_super) {
    __extends(UploadRequest, _super);
    function UploadRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Request a new upload
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-request/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadRequest.prototype.create = function (body) {
        return this.rawCreate(Utils.serializeRequestBody(body, {
            type: 'upload_request',
            attributes: ['filename'],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Request a new upload
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-request/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadRequest.prototype.rawCreate = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/upload-requests',
            body: body,
        });
    };
    UploadRequest.TYPE = 'upload_request';
    return UploadRequest;
}(BaseResource));
export default UploadRequest;
//# sourceMappingURL=UploadRequest.js.map